import React from 'react';
import styled from 'styled-components';
import AddressesPageHeading from 'components/AddressesPageHeading';
import PropTypes from 'prop-types';
import { FullWidthPageContent } from 'layouts/SingleColumnLayout';
import DeliveryAddress from 'components/DeliveryAddress';

const PageContent = styled(FullWidthPageContent)`
  .DeliveryAddress {
    margin-bottom:${({ theme }) => theme.spacing * 2}px;
  }
`;

const Component = ({ addresses }) => (
  <>
    <AddressesPageHeading />
    <PageContent>
      {addresses.map((address) => (
        <DeliveryAddress key={address.id} address={address} />
      ))}
    </PageContent>
  </>
);

Component.propTypes = {
  addresses: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
export default Component;
